import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LogoutCircleFillComponent, UserSettingsFillComponent, WalletFillComponent } from '@core/ui-kit/components';
import { TranslocoPipe } from '@jsverse/transloco';
import { TippyDirective } from '@ngneat/helipopper';
import { AuthStore, Role, User } from '@shared/data-access/data-access-authentication';

import { TokenStore } from '../../../data-access/data-access-token';
import { RoleDirective } from '../../../directives/role.directive';

@Component({
  selector: 'app-user-avatar',
  imports: [
    NgOptimizedImage,
    TippyDirective,
    TranslocoPipe,
    RouterLink,
    WalletFillComponent,
    LogoutCircleFillComponent,
    UserSettingsFillComponent,
    RoleDirective,
  ],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {
  private readonly tokenStore = inject(TokenStore);
  private readonly authStore = inject(AuthStore);

  user = input.required<User>();
  logout = output<void>();

  isTrial = this.tokenStore.isTrial;
  isOrganizationOwner = this.authStore.isOrganizationOwner;
  // The entry opens the Stripe customer portal: a Pay as you go organisation, sold as
  // "No subscription", only finds its invoices and cards there.
  portalMenuLabel = computed(() =>
    this.tokenStore.isPayAsYouGo() ? 'navbar.menu.billing' : 'navbar.menu.subscription',
  );

  Role = Role;

  createPortalSession(): void {
    this.tokenStore.createPortalSession();
  }
}
